module.exports = __webpack_public_path__ + "static/media/reports_inventory.f02f5fe0.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_inventory.md
// module id = 1112
// module chunks = 0